var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("i", {
    class: _vm.classObject,
    staticStyle: { cursor: "pointer", "margin-right": "10px", display: "none" },
    on: { click: _vm.handleChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }